import * as actions from 'actions/types';

const checkServer = action => {
  const serverIsDown =
    action.payload &&
    ((action.payload.response && action.payload.response.status === 503) ||
      action.payload.message === 'Network Error');

  return { serverIsDown };
};

export default function(state = null, action) {
  switch (action.type) {
    case actions.GET_SYSTEM_INFO:
    case actions.SIGN_AGREEMENT:
    case actions.DOWNLOAD_SIGNED_AGREEMENT:
    case actions.DOWNLOAD_AGREEMENT_BLANK:
    case actions.GET_AGREEMENT_INFO:
    case actions.FETCH_REQUEST_COMMENTS:
    case actions.POST_COMMENT:
    case actions.FETCH_DEVICE_LIST:
    case actions.FETCH_AUTHORIZED_LABS:
    case actions.FETCH_MODEL_VERSIONS:
    case actions.FETCH_MODEL:
    case actions.CHECK_FCC_ID:
    case actions.CHECK_EXISTED_MODEL:
    case actions.FETCH_REQUEST:
    case actions.UPDATE_USERS_MANUAL:
    case actions.UPDATE_REQUEST_STATUS:
    case actions.CREATE_DEVICE_MODEL:
    case actions.UPDATE_DEVICE_MODEL:
    case actions.FETCH_POCS:
    case actions.CREATE_NEW_POC:
    case actions.USERS_MANUAL_DOWNLOAD:
    case actions.GET_USERS_MANUAL_INFO:
    case actions.DOCUMENT_DOWNLOAD:
    case actions.UPDATE_PUBLICATION_OPTIONS:
    case actions.DELETE_DOCUMENT:
    case actions.UPDATE_REQUEST:
    case actions.SUBMIT_INITIAL_REQUEST:
    case actions.SUBMIT_ECO_REQUEST:
    case actions.WITHDRAW_REQUEST:
    case actions.UNWITHDRAW_REQUEST:
    case actions.SEARCH_REQUEST:
    case actions.FETCH_CERTIFICATION_REQUESTS:
    case actions.FETCH_APPROVE_WAITING_REQUESTS:
    case actions.FETCH_MODEL_LIST:
    case actions.FETCH_REQUEST_TESTS:
    case actions.SEND_TEST_RESULT:
    case actions.DOWNLOAD_TEST_REPORT:
    case actions.FETCH_TEST_REPORTS:
    case actions.UPDATE_REPORT_STATUS:
    case actions.DELETE_TEST_REPORT:
    case actions.UPLOAD_SUPPORT_DOC:
    case actions.UPLOAD_USERS_MANUAL:
    case actions.DELETE_USERS_MANUAL:
    case actions.DELETE_SUPPORT_DOCUMENT:
    case actions.UPLOAD_TEST_REPORT:
    case actions.UPDATE_DOCUMENT_TITLE:
    case actions.AGREE_TERMS:
      return checkServer(action, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/system.js